import { useState } from 'react';
import intl from 'components/i18n/ReactIntlWrapper';
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Stack } from '@mui/material';
import CorporateEntitiesSearchBar from './CorporateEntitiesSearchBar';
import CountrySelect from '../common/Selects/CountrySelect';
import { useNavigate } from "react-router";


const CorporateEntitiesNavbar = ({ onSearch, countries }) => {
  const [queryString, setQueryString] = useState<string>('');
  const navigate = useNavigate();


  const [country, setCountry] = useState({
    id: null,
    name: '',
    labelKey: ''
  });

  const handleSearchButton = () => {
    onSearch(queryString, country.id);
  };

  const handleCountryChange = (e) => {
    if (e !== null) {
      setCountry({
        id: e.id,
        name: intl.get(e.labelKey),
        labelKey: e.labelKey
      });
    } else {
      setCountry({
        id: null,
        name: '',
        labelKey: ''
      });
    }
  };

  return (
    <Box
      component="nav"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      sx={{ px: 2, py: 1 }}
    >
      <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" sx={{ flexGrow: 1 }}>
        <CorporateEntitiesSearchBar queryString={queryString} setQueryString={setQueryString} />
        <CountrySelect
          handleCountryChange={handleCountryChange}
          selectedCountry={country.labelKey}
          countries={countries}
          inputCountry={country.name}
          isClearable={true}
        />
        <Button
          variant="outlined"
          color="primary"
          startIcon={<SearchIcon />}
          onClick={handleSearchButton}
        >
          Search
        </Button>
      </Stack>

      <Button  sx={{ height: 40 }} onClick={() => navigate(`/corporateEntities/new`)}>
            <AddIcon /> {intl.get('corporateEntity.new') ? intl.get('corporateEntity.new') : intl.get('button.new')}
      </Button>
    </Box>
  );
};

export default CorporateEntitiesNavbar;
